module.exports = __webpack_public_path__ + "static/meadow-b944f1d7914bcb7778ba26e9ae7efaa3.jpg";